module.exports = __webpack_public_path__ + "img/fbWhite.641f2d4b.svg";